define({
    assets: {
      icon: '/v1.0/Category/{item_id}/icon/{shelf_type}/1/web/{status}.png'
    }
  });
